import { SEGMENTS } from '@sparknz/journeys-common';

import { ProductDetailsQuery$data } from '__generated__/ProductDetailsQuery.graphql';
import { MetaTagsProps } from 'shared/components/MetaTags';

export interface ProductDetailsMeta {
  product: ProductDetailsQuery$data;
  segment: MetaTagsProps['segment'];
  groupId: string;
}

const constructMetaTitleBlurb = (
  segment: MetaTagsProps['segment'],
  productGroupName?: string,
) => {
  switch (segment) {
    case SEGMENTS.BUSINESS:
      return `${productGroupName} | Shop Now`;
    case SEGMENTS.PERSONAL:
      return `${productGroupName} | Buy yours from Spark`;
    default:
      return productGroupName;
  }
};

export function formatProductDetailsMeta({
  product,
  segment,
  groupId,
}: ProductDetailsMeta): MetaTagsProps {
  const {
    productData: { offerDetails },
  } = product;

  return {
    title: constructMetaTitleBlurb(segment, offerDetails?.[0]?.groupName),
    description: offerDetails?.[0]?.description,
    segment,
    image: offerDetails?.[0]?.images?.[0]?.defaultUrl,
    canonicalUrl: `products/${groupId}/`,
  };
}
